<template>
  <div class="container">
    <form class="needs-validation" id="login-form" @submit.prevent="validateForm" data-toggle="validator" novalidate>

      <div class="col-12 col-lg-12 clear-padding-left" v-if="this.sendSuccessful">
        <div class="form-group-container">
          <h1 class="page-title">Reset instructions sent!</h1>
          <div class="alert alert-success">
            <p class="">Reset email has been sent to your email address.</p>
            <p>Please check your junk folder as well as your inbox for this email.</p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-12 clear-padding-left" v-if="this.submitMessage != null && this.submitMessage.length > 0">
        <div class="alert alert-danger">
          <p class="">{{this.submitMessage}}</p>
          <div v-for="(error, index) in this.errors" :key="index">
            <p>{{error}}</p>
          </div>
        </div>
      </div>

      <div class="col-12 col-lg-6 center-align" v-if="!this.sendSuccessful">
        <div class="form-group-container">

          <h1 class="page-title text-center icon-title"><span class="icon-circle center"><i class="fa fa-unlock" aria-hidden="true"></i></span><span>Can&rsquo;t Access Your Account? </span> </h1>

          <div class="col-12 col-md-12 center-align">
            <div class="form-group row">
              <p class="text-center">Enter your email address below, a reset password link will be sent to you.</p>
            </div>
            <div class="form-group row">
              <label for="item.email" class="col-12 col-lg-5 col-form-label">Email</label>
              <div class="col-12 ">
                <input type="text" class="form-control" id="item.email" v-model="item.email">
                <Tooltip v-show="this.emailTooltip" helpText="Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. " />
                <div class="bg-danger text-white col-12 clear-padding-left text-danger error-message" v-show="this.errors.hasKey('item.email')"><span class="" v-text="this.errors.getPropByKey('error', 'item.email')"></span></div>
              </div>
            </div>

            <div class="form-group row">
              <div class="col-12 col-lg-5"></div>
              <div class="col-12 ">
                <div class="row">
                  <div class="col-12 col-md-12 login-btns">
                    <button type="submit" class="btn default-btn-color btn-primary">Next</button>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
/* eslint-disable */
import { UserService } from "@/services/UserServices/UserService";
import { authMethods, authComputed, authMutations } from "@/state/helpers";
import rbValidator from "@/mixins/rbValidator";
import Tooltip from "@/components/controls/Tooltip.vue";
import * as Validators from "@/utils/validators";
import * as FormFieldValidators from "@/utils/form-field-validators";
import commonMixin from "@/mixins/commonMixin";
var validations = {
  "item.email": FormFieldValidators.emailAddress
};
export default {
  name: "ForgottenPassword",
  mixins: [commonMixin, rbValidator],
  components: {
    Tooltip
  },
  data() {
    return {
      item: {
        email: ""
      },
      validations: validations,
      emailTooltip: false,
      passwordTooltip: false,
      attemptingLogin: false,
      authError: null,
      submitMessage: "",
      errors: [],
      sendSuccessful: false
    };
  },
  computed: {
    ...authComputed
  },
  methods: {
    ...authMethods,
    validateForm(event) {
      event.preventDefault(event);
      this.validate("login-form", this.validations);

      if (this.errors.length === 0) {
        this.canProceed = true;
        //this.$router.push('/my-account');
        this.processForgottenPassword();
        return;
      }

      this.canProceed = false;
      this.scrollToTop("login-form");
    },
    async processForgottenPassword() {
      this.authError = null;
      this.submitMessage = "";
      var response = await UserService.forgotPassword(
        JSON.parse(JSON.stringify(this.item))
      );
      if (response.success) {
        this.sendSuccessful = true;
        //this.redirectToRoute("/my-account");
      } else {
        //this.errors = response.data;
        this.submitMessage = response.message;
        this.sendSuccessful = false;
      }
      this.loaded = true;
    }
  },
  mounted() {
    this.sendSuccessful = false;
    this.init("login-form", this.validations);
    this.scrollToTop("login-form");
  }
};
</script>

<style scoped>
</style>